import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class ReportsService extends CentralService {

  protected resource: string = "reports";

}
